module.exports = __webpack_public_path__ + "img/nature (1)-1.237f055b.svg";